module.exports = __webpack_public_path__ + "img/applicant.bac4f02e.svg";